import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { CheckboxAndRadio, FormControls } from "../../../Constant";
import DefaultCheckbox from "./DefaultCheckbox";
import CustomCheckbox from "./CustomCheckbox";
import DefaultRadio from "./DefaultRadio";
import ImagesWithCheckbox from "./ImagesWithCheckbox";
import ImagesWithRadio from "./ImagesWithRadio";
import CustomRadio from "./CustomRadio";
import DefaultSwitches from "./DefaultSwitches";
import InlineInputTypes from "./InlineInputTypes";
import AnimatedButtons from "./AnimatedButtons";
import BasicRadioAndCheckbox from "./BasicRadioAndCheckbox";
import RadiooggleButtons from "./RadiooggleButtons";
import OutlinedCheckboxStyles from "./OutlinedCheckboxStyles";

const CheckboxRadioContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={CheckboxAndRadio} parent={FormControls} title={CheckboxAndRadio} />
      <Container fluid>
        <Row>
          <DefaultCheckbox />
          <CustomCheckbox />
          <DefaultRadio/>
          <ImagesWithCheckbox/>
          <ImagesWithRadio/>
          <CustomRadio/>
          <DefaultSwitches/>
          <InlineInputTypes/>
          <AnimatedButtons/>
          <BasicRadioAndCheckbox/>
          <RadiooggleButtons/>
          <OutlinedCheckboxStyles/>
        </Row>
      </Container>
    </>
  );
};

export default CheckboxRadioContainer;
